export default {
  ttarp_test_v2: {
    flags: {
      test: 0.5,
      control: 0.5,
    },
  },
  cart_count_v1: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0,
    },
  },
};
